import { Farbmenuselect } from "./Farbmenuselect";
import { AuswahlAccessor } from "../Auswahl";

export function PfostenOptionen() {
  const agt = APP.arrangement;
  const selected = agt.selectedObjects;
  const showPfostenTab =
    selected.length === 0 ||
    (selected.some((e) => e.isPfosten) && !selected.every((e) => e.isMontageplatten));

  if (!showPfostenTab) {
    return null;
  }

  return showPfostenTab ? (
    <div key="pfosten-tabs" className="options-tab">
      <PfostenTab />
    </div>
  ) : null;
}

export function PfostenTab() {
  const agt = APP.arrangement;
  const selected = agt.selectedObjects;
  const einzelnerPfostenSelected =
    selected.length === 1 && selected[0].isPfosten ? selected[0] : null;

  const { Pfostenfarbe } = agt.auswahlAccessoren;

  return (
    <>
      <div
        className="flex column-container"
        data-group-key="Pfosten"
        role="group"
        aria-label={I18N("aria::Pfostenoptionen")}
      >
        <div
          className="flex column-container w-full"
          data-select-key="Pfostenfarbe"
          data-value={Pfostenfarbe.auswahlwert?.Key}
          role="radiogroup"
          aria-label={I18N("aria::Pfostenfarbe auswählen")}
        >
          {Pfostenfarbe.möglicheAuswahlwerte.length > 0 && (
            <Farbmenuselect
              auswahlwerte={Pfostenfarbe.möglicheAuswahlwerte}
              value={Pfostenfarbe.auswahlwert}
              onChange={Pfostenfarbe.setter}
              className="pfosten-item"
            />
          )}
        </div>
        {!einzelnerPfostenSelected?.isUnechterpfosten && (
          <div className="flex column-container">
            <AuswahlAccessor accessorKey="Pfostenart" />
            <AuswahlAccessor accessorKey="Bodenbefestigung" />
            <AuswahlAccessor accessorKey="Verbundanker" />
            <AuswahlAccessor accessorKey="Montageadapter" />
            <AuswahlAccessor accessorKey="Ummantelung" />
            <AuswahlAccessor accessorKey="Elementhalter" />
            <AuswahlAccessor accessorKey="Pfostenkappe" />
          </div>
        )}
      </div>
    </>
  );
}
